/**
 * Button primitive — handoff "Componentes.dc" (Plus Jakarta Sans, pill).
 * Variants/props kept identical: primary | secondary | ghost | dark | danger.
 * Visual only — no behavior changes.
 */
import { cn } from '@/lib/utils'

// Estilos por variante (solo apariencia). Se usan via inline style para no
// depender de tokens bloqueados (expo-primary/yellow/dark los usan Sidebar/Header).
const VARIANT_STYLE = {
  primary: { background: '#033021', color: '#FFFFFF', border: '1.5px solid #033021' },
  secondary: { background: '#FFFFFF', color: '#1E6E3A', border: '1.5px solid #1E6E3A' },
  ghost: { background: 'transparent', color: '#15321F', border: '1.5px solid transparent' },
  dark: { background: '#14502A', color: '#FFFFFF', border: '1.5px solid #14502A' },
  danger: { background: '#C0392B', color: '#FFFFFF', border: '1.5px solid #C0392B' },
}

const VARIANT_HOVER = {
  primary: 'hover:brightness-110',
  secondary: 'hover:bg-[#E3F0D5]',
  ghost: 'hover:bg-black/5',
  dark: 'hover:brightness-110',
  danger: 'hover:brightness-110',
}

const SIZES = {
  sm: 'px-4 py-2 text-sm',
  md: 'px-6 py-3 text-[15px]',
  lg: 'px-7 py-3.5 text-[15px]',
}

export function Button({
  variant = 'primary',
  size = 'md',
  className,
  children,
  style,
  ...props
}) {
  return (
    <button
      className={cn(
        'inline-flex items-center justify-center gap-2 font-bold press transition-all disabled:opacity-50 disabled:cursor-not-allowed rounded-full',
        VARIANT_HOVER[variant],
        SIZES[size],
        className
      )}
      style={{ fontFamily: "'Plus Jakarta Sans', sans-serif", ...VARIANT_STYLE[variant], ...style }}
      {...props}
    >
      {children}
    </button>
  )
}
